import * as React from 'react';
import { BarkerApi, App } from '../interfaces';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { EventSearchService } from '../services/event-search-service';
import * as Autocomplete from 'react-autocomplete';
import classNames from 'classnames';

interface EventSearchProps {
  postTypes: string[];
}

interface AutoCompleteEventResult {
  text: string;
  value: string;
}

interface EventSearchState {
  autoCompleteEventResults: AutoCompleteEventResult[];
  searchTerm: string;
}

export class EventSearch extends React.Component<EventSearchProps, EventSearchState> {

  static defaultProps: Partial<EventSearchProps> = {
    postTypes: []
  };

  private _search = new Subject<string>();
  search = this._search.asObservable();
  searchSub = new Subscription;

  state = {
    autoCompleteEventResults: [],
    searchTerm: ''
  }

  eventSearchService = new EventSearchService();

  componentWillMount() {

    this.searchSub = this.search.debounceTime(750).distinctUntilChanged().filter(search => search !== "").flatMap(
      (search) => this.eventSearchService.search(search, this.props.postTypes)
    ).map(
      (eventResults) => eventResults.map(
        (eventResult) => ({
          text: eventResult.title.rendered,
          value: eventResult.link
        }) as AutoCompleteEventResult
      )
      ).subscribe(
        (autoCompleteEventResults) => this.setState({ autoCompleteEventResults })
      );

  }

  componentWillUnmount() {

    if (this.searchSub) { this.searchSub.unsubscribe(); }

  }

  handleUpdateSearch(searchTerm: string) {

    this.setState( { searchTerm: searchTerm });
    this._search.next(searchTerm);

  }

  handleChangeEvent(url: string) {

    window.location.href = url;

  }

  render() {

    return <div className="field">
      <div className="control is-expanded">
        <Autocomplete
          getItemValue={(item) => item.value }
          items={ this.state.autoCompleteEventResults }
          renderItem={(item, isHighlighted) => <li><a href="#" tabIndex={0} className={ classNames({ 'is-active': isHighlighted })}>{ item.text }</a></li>}
          onChange={(e, searchTerm) => this.handleUpdateSearch(searchTerm)}
          onSelect={(result) => this.handleChangeEvent(result) }
          value={ this.state.searchTerm }
          selectOnTab={true}
          wrapperStyle={ { display: 'block' }}
          inputProps={ { placeholder: 'Search for movie, event...', className: 'input is-medium' }}
          renderMenu={ (items, value, style) => {

            return <div className="color-box is-white menu" style={{...style }}><ul className="menu-list" children={items}></ul></div> }

          }
        />
      </div>
    </div>;

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/event-search/event-search.tsx